// import React, { useState, useEffect } from "react";
// import { Tabs, Tab, Box, IconButton } from "@mui/material";
// import ListIcon from "@mui/icons-material/List";
// import BusinessIcon from "@mui/icons-material/Business";
// import CloseIcon from "@mui/icons-material/Close";

// import RiteClientList from "./RiteClientList";
// import RiteClientDetails from "./RiteClientDetails";

// import ApiServices from "../../../Utils/ApiServices/ApiServices";
// import { getDecryptedAccessToken } from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";

// const RiteClientTabs = () => {
//   const token = getDecryptedAccessToken();

//   const [clients, setClients] = useState([]);
//   const [tabs, setTabs] = useState([]);
//   const [selected, setSelected] = useState(0);

//   const fetchClients = async () => {
//     try {
//       const res = await ApiServices.get("/api/v1/clients/", {
//         Authorization: `Bearer ${token}`,
//       });

//       setClients(res.data.results || []);
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   useEffect(() => {
//     fetchClients();
//   }, []);

//   const openClient = (client) => {
//     const exist = tabs.findIndex((t) => t.client_id === client.client_id);

//     if (exist === -1) {
//       const newTabs = [...tabs, client];

//       setTabs(newTabs);
//       setSelected(newTabs.length);
//     } else {
//       setSelected(exist + 1);
//     }
//   };
      
//   const closeTab = (index) => {
//     const updated = tabs.filter((_, i) => i !== index);

//     setTabs(updated);
//     setSelected(0);
//   };

//   return (
//     <Box>
//       <Tabs
//         value={selected}
//         onChange={(e, v) => setSelected(v)}
//         variant="scrollable"
//       >
//         <Tab icon={<ListIcon />} label="Clients" />

//         {tabs.map((tab, index) => (
//           <Tab
//             key={tab.client_id}
//             label={
//               <Box display="flex" alignItems="center">
//                 {tab.legal_name}

//                 <IconButton
//                   size="small"
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     closeTab(index);
//                   }}
//                 >
//                   <CloseIcon fontSize="small" />
//                 </IconButton>
//               </Box>
//             }
//           />
//         ))}
//       </Tabs>

//       <Box mt={2}>
//         {selected === 0 && (
//           <RiteClientList
//             clients={clients}
//             onOpen={openClient}
//             refresh={fetchClients}
//           />
//         )}

//         {selected > 0 && (
//           <RiteClientDetails
//             client={tabs[selected - 1]}
//             refresh={fetchClients}
//           />
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default RiteClientTabs;


import React, { useState, useEffect } from "react";
import { Tabs, Tab, Box, IconButton } from "@mui/material";
import { useNavigate, useParams, useLocation } from "react-router-dom";

import ListIcon from "@mui/icons-material/List";
import CloseIcon from "@mui/icons-material/Close";

import RiteClientList from "./RiteClientList";
import RiteClientDetails from "./RiteClientDetails";

import ApiServices from "../../../Utils/ApiServices/ApiServices";
import { getDecryptedAccessToken } from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";

const RiteClientTabs = () => {
  const token = getDecryptedAccessToken();
  const navigate = useNavigate();
  const location = useLocation();
  const { clientId } = useParams();

  const [clients, setClients] = useState([]);
  const [tabs, setTabs] = useState([]);
  const [selected, setSelected] = useState(0);

  const fetchClients = async () => {
    try {
      const res = await ApiServices.get("/api/v1/clients/", {
        Authorization: `Bearer ${token}`,
      });

      setClients(res.data.results || []);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchClients();
  }, []);

  const openClient = (client) => {
    const exist = tabs.findIndex((t) => t.client_id === client.client_id);

    if (exist === -1) {
      const newTabs = [...tabs, client];
      setTabs(newTabs);
      setSelected(newTabs.length);
    } else {
      setSelected(exist + 1);
    }

    navigate(`/client-view/${client.client_id}/dashboard`);
  };

  const closeTab = (index) => {
    const closingTab = tabs[index];
    const updated = tabs.filter((_, i) => i !== index);

    setTabs(updated);

    if (updated.length === 0) {
      setSelected(0);
      navigate("/client-view");
      return;
    }

    if (selected === index + 1) {
      setSelected(0);
      navigate("/client-view");
      return;
    }

    if (selected > index + 1) {
      setSelected(selected - 1);
    }

    if (clientId && closingTab?.client_id?.toString() === clientId.toString()) {
      navigate("/client-view");
    }
  };

  const handleTabChange = (event, newValue) => {
    setSelected(newValue);

    if (newValue === 0) {
      navigate("/client-view");
    } else {
      const client = tabs[newValue - 1];
      if (client) {
        navigate(`/client-view/${client.client_id}/details`);
      }
    }
  };

  useEffect(() => {
    if (!clientId || clients.length === 0) {
      if (location.pathname === "/client-view") {
        setSelected(0);
      }
      return;
    }

    const clientFromList = clients.find(
      (c) => c.client_id?.toString() === clientId?.toString()
    );

    if (!clientFromList) return;

    const exist = tabs.findIndex(
      (t) => t.client_id?.toString() === clientId?.toString()
    );

    if (exist === -1) {
      const newTabs = [...tabs, clientFromList];
      setTabs(newTabs);
      setSelected(newTabs.length);
    } else {
      setSelected(exist + 1);
    }
  }, [clientId, clients]);

  return (
    <Box>
      <Tabs
        value={selected}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab icon={<ListIcon />} label="Clients" />

        {tabs.map((tab, index) => (
          <Tab
            key={tab.client_id}
            label={
              <Box display="flex" alignItems="center" gap={1}>
                <Box component="span">{tab.legal_name}</Box>

                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    closeTab(index);
                  }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>
            }
          />
        ))}
      </Tabs>

      <Box mt={2}>
        {selected === 0 && (
          <RiteClientList
            clients={clients}
            onOpen={openClient}
            refresh={fetchClients}
          />
        )}

        {selected > 0 && tabs[selected - 1] && (
          <RiteClientDetails
            client={tabs[selected - 1]}
            refresh={fetchClients}
          />
        )}
      </Box>
    </Box>
  );
};

export default RiteClientTabs;